<template>
  <div class="index-container">
    <img class="module-banner" src="/static/images/naiture/banner.png" />
    <div class="module-white module-white-1">
      <div class="auth-title">Authentication Information</div>
      <div class="auth-row auth-row-first">
        <span class="auth-label">Name:</span>
        <span class="auth-value">{{ productName }}</span>
      </div>
      <div class="auth-row">
        <span class="auth-label">Product Code:</span>
        <span class="auth-value">{{ productNo }}</span>
      </div>
      <div class="auth-row">
        <span class="auth-label">Retail Price:</span>
        <span class="auth-value">￥{{ price }}</span>
      </div>
    </div>
    <div class="module-white module-white-2">
      <div class="auth-title auth-title-bold">Authentication Information</div>
      <div class="auth-row auth-row-first">
        <div class="auth-value multiline" v-if="antiShow === 1">
          <div>THE QUERIED NAITURE SENSELIX IS GENUINE. <img class="true-img" src="/static/images/naiture/true.png" />
          </div>
          <div>Please use it with confidence!</div>
        </div>
      </div>
      <div class="auth-row">
        <span class="auth-label">First query time:</span>
        <span class="auth-value">{{ firstQueryTime }}</span>
      </div>
      <div class="auth-row auth-row-small-gap">
        <span class="auth-label">Previous query time:</span>
        <span class="auth-value">{{ preQueryTime || firstQueryTime }}</span>
      </div>
    </div>
    <div class="module-shop">
      <wx-open-launch-weapp class="shopnow-img" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
        <script type="text/wxtag-template">
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/shopnow-f8b8e3ce9acc4e0e82aeacf9efe71d20.png"
            style="width: 100%;height: auto;display: block;" />
        </script>
      </wx-open-launch-weapp>
    </div>
    <div class="modal-overlay" v-if="showModal">
      <div class="modal">
        <div class="modal-title">提示</div>
        <div class="modal-content">填写的防伪码不正确，请核对后再查询！</div>
        <div class="modal-button" @click="closeModal">重新填写</div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryAnti, getInfoByCode, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'NaitureIndex',
  data() {
    return {
      antiCode: '',
      firstQueryTime: '',
      preQueryTime: '',
      router: '',
      showModal: false,
      eno: process.env.ENV_NUM === '1' ? '138885179492' : '138582119094',
      appId: process.env.ENV_NUM === '1' ? 'wxbc22565b3e7a59fd' : 'wxbc22565b3e7a59fd',
      antiShow: 0,
      productName: '',
      productNo: '',
      price: '',
      miniAppId: 'wx6932940c372a1a36',
      miniAppOriginalId: 'gh_9e359a9afe41',
      miniAppPage: 'pages/home/dashboard/index'
    }
  },
  created() {
    this.getWxJs();
  },
  async mounted() {
    this.antiCode = this.$route.query.c || '';
    this.router = this.$route.query.router || '';

    if (this.router) {
      this.firstQueryTime = this.$route.query.firstQueryTime || '';
      this.preQueryTime = this.$route.query.preQueryTime || '';
      this.antiShow = 1;
      await this.getProductInfo();
    } else {
      await this.queryAntiCode();
      await this.getProductInfo();
    }
  },
  methods: {
    async queryAntiCode() {
      try {
        const res = await queryAnti(this.antiCode, this.eno);
        const data = res.data;

        if (data == null || data.code == "500") {
          this.showModal = true;
          return;
        }

        const replyCode = data.data.replyCode;

        if (replyCode === "300101" || replyCode === "300102") {
          this.firstQueryTime = data.data.firstQueryTime || '';
          this.preQueryTime = data.data.preQueryTime || '';
          this.antiShow = 1;
        } else if (replyCode === "300106") {
          this.showModal = true;
          return;
        } else {
          this.showModal = true;
          return;
        }
      } catch (error) {
        console.error('防伪查询失败:', error);
        this.showModal = true;
      }
    },
    async getProductInfo() {
      try {
        const res = await getInfoByCode(this.antiCode);
        if (res.data.code === "200" && res.data.data) {
          this.productName = res.data.data.productName || '';
          this.productNo = res.data.data.productNo || '';
          const priceNum = parseFloat(res.data.data.price);
          this.price = priceNum % 1 === 0 ? priceNum.toString() : res.data.data.price;
        }
      } catch (error) {
        console.error('获取产品信息失败:', error);
      }
    },
    closeModal() {
      this.showModal = false;
      window.location.href = '/naiture/query';
    },
    getWxJs() {
      const originalUrl = window.location.href.split('#')[0].trim()
      const url = encodeURIComponent(originalUrl)
      
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        
        if (!data) {
          return
        }
        
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        
        wx.ready(() => {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
        
        wx.error((res) => {
          console.error('wx.error:', res)
        });
      }).catch(err => {
        console.error('获取微信授权失败:', err)
      })
    }
  }
}
</script>

<style scoped>
.index-container {
  width: 100vw;
  height: 100vh;
  background-color: rgb(204, 204, 204);
  display: flex;
  flex-direction: column;
}

.module-banner {
  width: 90vw;
  margin: 3vh auto 3vh auto;
}

.module-white {
  width: 90vw;
  height: 22vh;
  background-color: white;
  border-radius: 10px;
  margin: 0 auto;
}

.module-white-1 {
  margin-bottom: 2vh;
  padding: 2vw 5vw;
  display: flex;
  flex-direction: column;
  gap: 2vw;
  justify-content: center;
}

.auth-title {
  font-size: 4.3vw;
  color: rgb(31, 103, 106);
  font-weight: 500;
}

.auth-row {
  display: flex;
  align-items: flex-start;
  font-size: 3.2vw;
}

.auth-row-first {
  margin-top: 2vh;
}

.module-white-2 .auth-row-first {
  margin-top: 3vh;
}

.auth-row-small-gap {
  margin-top: 1vh;
}

.auth-label {
  font-weight: 400;
  margin-right: 2vw;
  color: black;
}

.auth-value {
  color: black;
  font-weight: 400;
}

.module-white-2 {
  margin-bottom: 6vh;
  padding: 2vw 5vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.module-white-2 .auth-row {
  margin-top: 2vh;
}

.module-white-2 .auth-row-small-gap {
  margin-top: 0.5vh;
}

.module-white-2 .auth-label {
  font-weight: bold;
}

.module-white-2 .auth-value {
  font-weight: bold;
}

.multiline {
  display: flex;
  flex-direction: column;
  gap: 1vh;
}

.multiline>div {
  display: flex;
  align-items: center;
}

.true-img {
  width: 4vw;
  height: 4vw;
  margin-left: 1vw;
}

.module-shop {
  width: 90vw;
  height: 10vh;
  background-color: white;
  border-radius: 10px;
  margin: 0 auto;
  padding: 2vw;
  display: flex;
  flex-direction: column;
  gap: 2vw;
  justify-content: center;
}

.auth-title-bold {
  font-weight: bold;
}

.shopnow-img {
  max-width: 90%;
  margin-top: 1.5vh;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background-color: rgba(64, 64, 64, 0.9);
  border-radius: 15px;
  padding: 30px 20px;
  width: 80vw;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.modal-title {
  font-size: 6vw;
  font-weight: bold;
  color: white;
}

.modal-content {
  font-size: 4.5vw;
  text-align: center;
  color: white;
  max-width: 70%;
}

.modal-button {
  padding: 10px 50px;
  background-color: rgb(88, 171, 139);
  color: white;
  border-radius: 25px;
  font-size: 4.5vw;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Naiture/Index.vue